import { Component, OnInit} from '@angular/core';
import { ModalService } from '../services/modal.service';
import { FormControl, FormGroup, Validators, NgForm } from '@angular/forms';
  

import Swal from 'sweetalert2';
import { UsuarioService } from '../services/usuario/usuario.service';

//models
import { Usuario } from '../models/usuario.model';


declare function init_plugins();
@Component({
  standalone: false,
  selector: 'app-registra-modal',
  templateUrl: './registra-modal.component.html',
  styles: []
})
export class RegistraModalComponent implements OnInit {
  public largeModal;
  forma: FormGroup;
  oculto:string='';
  rucExiste:boolean=false;
  emailExiste:boolean=false;
  loadRuc:boolean=false;
  loadEmail:boolean=false;
  loadRegister:boolean=false;

  textoRegistrar:String="Regístrate";
  usuario=new Usuario();

  constructor(
    public _modalRegister:ModalService,
    public _usuariService:UsuarioService

  ) { 
    
  }

  ngOnInit() {
    this.usuario=new Usuario();
  }

  subirImagen(){}
  
  cerrarModal(){
    init_plugins();
    this._modalRegister.ocultarModal();
  }

  registrarUsuario( f: NgForm){
    this.loadRegister=true;
    this.textoRegistrar="Cargando";
    if ( f.invalid ) {
      this.loadRegister=false;
      this.textoRegistrar="Registrar";
      return;
    }
    if (!this.usuario.condiciones) {
      Swal.fire('Importante', 'Debe de aceptar las condiciones', 'warning');
      this.loadRegister=false;
      this.textoRegistrar="Registrar";
      return;
    }
    this._usuariService.crearUsuario(this.usuario).subscribe( resp => {
      this.loadRegister=false;
      this.textoRegistrar="Registrar";
      this._modalRegister.ocultarModal();
      this.usuario=new Usuario();
    });

    
  }
 

  buscaRuc(){
   
    // var ruc = this.usuario.ruc+"";
    // this.loadRuc=true;
    // if(ruc.length==11){      
    //   this._usuariService.buscaSiExiste(ruc).subscribe( resp => {                
    //     if(resp.ok==false){         
    //       this._usuariService.consultaRuc(ruc).subscribe( respc => {
    //         if(respc.ok){ 
    //           if(respc.message=='ERRORURL'){
    //             this.rucExiste=false;           
    //             this.loadRuc=false;  
    //             Swal.fire('Consulta sunat','No fue posible validar el ruc', 'warning');   
    //           }else{
    //             this.usuario.razonSocial=respc.data.cliente.nombre_o_razon_social;  
    //           this.rucExiste=false;           
    //           this.loadRuc=false;    
    //           }
              
                            
    //         }else{
    //           this.rucExiste=true;
    //           this.usuario.razonSocial="";
    //           this.usuario.ruc="";
    //           this.loadRuc=false;   
    //         }
    //       },error=>{
    //        Swal.fire('Consulta sunat','Error durante la consulta del ruc', 'error');      
    //        this.usuario.razonSocial="";   
    //        this.usuario.ruc="";   
    //        this.rucExiste=true;
    //        this.loadRuc=false;   
    //       })          
    //     }else{
    //       this.rucExiste=true;
    //       this.usuario.razonSocial="";
    //       this.usuario.ruc="";
    //       this.loadRuc=false;   
    //     }
    //   },error=>{
    //     Swal.fire('Consulta ruc', 'Error consultando el ruc', 'error');   
    //     this.usuario.razonSocial="";   
    //     this.usuario.ruc="";   
    //     this.rucExiste=true;
    //     this.loadRuc=false;   
    //   });
    // }else{
    //   Swal.fire('Importante', 'El ruc ingresado no es valido,Debe ingresar 11 digitos', 'warning');
    //   this.usuario.razonSocial="";    
    //   this.loadRuc=false;   
    // }
   
  }

  buscaEmail(){
   
    var email = this.usuario.email+"";
    this.loadEmail=true;
    if(email.length>0){
      this._usuariService.buscaSiExisteEmail(email).subscribe( resp => {                
        if(resp.estado==1){     
          this.emailExiste=true;    
          this.usuario.email="";  
          this.loadEmail=false;
        }else{
          this.emailExiste=false;    
          this.loadEmail=false;
        }
      });
    }else{
      Swal.fire('Importante', 'El email ingresado no es valido', 'warning');
    }
  
  }

}
